export enum ConductTableFilterTypes {
  Competition = "competition",
  Season = "season",
  ConductType = "conductType",
  Status = "status",
}
